import styled from "@emotion/styled";
import { Theme } from "@silvertours/front-shared";
var UspContainer = /*#__PURE__*/ styled("div", {
    target: "e13hd7ob0"
})("display:flex;flex-direction:column;");
var UspItems = /*#__PURE__*/ styled("div", {
    target: "e13hd7ob1"
})("display:flex;flex-direction:column;gap:0.5rem;", Theme.mq("lg"), "{flex-direction:row;}");
var UspItem = /*#__PURE__*/ styled("div", {
    target: "e13hd7ob2"
})("display:flex;flex:1;margin:0 0 1.5rem;", Theme.mq("lg"), "{margin:0.5rem 0;}");
var UspTitleContainer = /*#__PURE__*/ styled("div", {
    target: "e13hd7ob3"
})("margin-bottom:1rem;");
var UspTitle = /*#__PURE__*/ styled("div", {
    target: "e13hd7ob4"
})("color:", Theme.Color.secondary100, ";margin:0 0 0.5rem;font-family:", function(param) {
    var theme = param.theme;
    return theme.fontFamily.alternate;
}, ";font-size:1.375rem;font-weight:normal;line-height:1.125;a{color:inherit;}");
var RatingContainer = /*#__PURE__*/ styled("div", {
    target: "e13hd7ob5"
})("display:flex;flex-direction:row;align-items:flex-end;gap:1rem;margin-top:0.5rem;");
var IconWrapper = /*#__PURE__*/ styled("div", {
    target: "e13hd7ob6"
})("margin-right:0.3125rem;fill:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";svg{width:45px;height:45px;}");
export { IconWrapper, RatingContainer, UspContainer, UspItem, UspItems, UspTitleContainer, UspTitle };
